/**********************************************************************
 * src/utils/file.js
 *********************************************************************/
// Converte un oggetto File/Blob in data-URL base-64.
// Ritorna una Promise che risolve con la stringa completa: "data:...;base64,AAAA..."
export const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload  = () => resolve(reader.result)
      reader.onerror = (err) => reject(err)
    })
  